import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { media } from "../../data/media";
import { products } from "../../data/products";
import { formatPrice, shopifyImg } from "../../utils/format";
import { btnPrimary, container, ease } from "../../utils/styles";
export function Hero() {
  const [hotspot, setHotspot] = useState(false);
  const flow = products.find(p => p.id === "flow")!;
  return <section aria-label="Welkom" className="relative bg-sand" data-id="element-159" data-mp="5onsgrpa5dfv">
      <div className="relative h-[58svh] min-h-[380px] overflow-hidden lg:h-[calc(100svh-108px)] lg:max-h-[820px] lg:min-h-[600px]" data-id="element-160" data-mp="q43sjjaxnjt">
        <motion.img src={media.hero} alt="Woonkamer met een sculpturale witte tafellamp op een eikenhouten dressoir" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        ease
      }} className="absolute inset-0 h-full w-full object-cover object-[60%_center] lg:object-center" data-id="element-161" data-mp="3rxyswsg7m3nh" />

        <div className="absolute left-[53%] top-[48%] hidden -translate-x-1/2 -translate-y-1/2 lg:block" onMouseEnter={() => setHotspot(true)} onMouseLeave={() => setHotspot(false)} data-id="element-162" data-mp="1rv5nnzcv11yb">
          <button type="button" onClick={() => setHotspot(h => !h)} aria-expanded={hotspot} aria-label="Bekijk een vergelijkbare lamp" className="relative flex h-8 w-8 items-center justify-center rounded-full bg-paper/90 shadow-md backdrop-blur" data-id="element-163" data-mp="1hx9irpain38n">
            <span className="absolute inset-0 animate-ping rounded-full bg-paper/60 motion-reduce:hidden" data-id="element-164" data-mp="1vxka0tfqmjuc" />
            <span className="relative h-2.5 w-2.5 rounded-full bg-ink" data-id="element-165" data-mp="20vbytel35pub" />
          </button>
          <AnimatePresence data-id="element-166" data-mp="2ol6b9v1htce1">
            {hotspot && <motion.div initial={{
            opacity: 0,
            y: 6,
            scale: 0.97
          }} animate={{
            opacity: 1,
            y: 0,
            scale: 1
          }} exit={{
            opacity: 0,
            y: 6,
            scale: 0.97
          }} transition={{
            duration: 0.18,
            ease
          }} className="absolute left-1/2 top-11 w-64 -translate-x-1/2" data-id="element-167" data-mp="2ojlioayqo3it">
                <Link to={`/product/${flow.id}`} className="flex items-center gap-3 rounded-xl bg-paper p-2.5 pr-4 shadow-xl" data-id="element-168" data-mp="2u6xg45774uei">
                  <img src={shopifyImg(flow.image, 160)} alt="" className="h-14 w-14 rounded-lg object-cover" data-id="element-169" data-mp="2p840o78cmtbp" />
                  <span className="min-w-0 flex-1" data-id="element-170" data-mp="2kau3u6imrfdu">
                    <span className="block text-xs text-muted" data-id="element-171" data-mp="2fias7f3i6ubo">Shop de look</span>
                    <span className="block truncate text-sm font-medium text-ink" data-id="element-172" data-mp="2ajg90c1mj3r1">{flow.name}</span>
                    <span className="text-sm text-ink" data-id="element-173" data-mp="26ie69l8i09kb">{formatPrice(flow.price)}</span>
                  </span>
                  <ArrowRightIcon className="h-4 w-4 shrink-0 text-ink" data-id="element-174" data-mp="21jkqfm5qo6gz" />
                </Link>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>

      <div className="lg:pointer-events-none lg:absolute lg:inset-0" data-id="element-175" data-mp="c260taopewsn">
        <div className={`${container} flex h-full items-center py-10 lg:py-0`} data-id="element-176" data-mp="c40a1rqm50gw">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease
        }} className="max-w-[540px] lg:pointer-events-auto" data-id="element-177" data-mp="gzfnwjomewdb">
            <h1 className="text-[42px] font-medium leading-[1.02] tracking-[-0.04em] text-ink sm:text-6xl xl:text-[76px]" data-id="element-178" data-mp="3ph2c8h5awy3y">
              Custom ontworpen. Met aandacht geproduceerd.
            </h1>
            <p className="mt-6 max-w-md text-[17px] leading-relaxed text-ink/70" data-id="element-179" data-mp="2ccq0bwdylpg">
              Sculpturale lampen, woondecoratie en persoonlijke cadeaus — gemaakt in onze studio in Nederland.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-180" data-mp="36quekekdezv5">
              <Link to="/shop?categorie=Verlichting" className={btnPrimary} data-id="element-181" data-mp="36ohy65u9gxk7">
                Shop verlichting <ArrowRightIcon className="h-4 w-4" data-id="element-182" data-mp="3aptipwya2slj" />
              </Link>
              <Link to="/shop" className="text-sm font-medium text-ink underline decoration-ink/30 underline-offset-[6px] transition-colors duration-150 hover:decoration-ink" data-id="element-183" data-mp="2rnswxhbzqr0s">
                Bekijk alle producten
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}